import React from "react";
import RiveComponent from "../../Shared/RiveComponent";

export class CasinoMaratonBanner extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            days: '00',
            hours: '00',
            minutes: '00',
            seconds: '00',
            promotionText: 'Trajanje promocije',
            startPromotion: false,
            timerNajava: null,
            countDownTimer: null,
            promotionFinished: false
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.info !== this.props.info && this.props.info != null) {
            var startDateTime = new Date(this.props.info.aktivnoOd);
            var endDateTime = new Date(this.props.info.aktivnoDo);

            if (new Date() < startDateTime) {
                this.startBannerCountDownTime(startDateTime);
            } else {
                this.startBannerCountDownTime(endDateTime);
            }

            this.checkPromotionDate(startDateTime, endDateTime);
            this.setState({ timerNajava: window.setInterval(() => this.checkPromotionDate(startDateTime, endDateTime), 1000) });
        }
    }

    /**
     * Lifeclye method
     */
    componentWillUnmount() {
        clearInterval(this.state.countDownTimer);
        clearInterval(this.state.timerNajava);
    }

    /**
     * Method for start counter
     * @param {*} endDateTime 
     */
    startBannerCountDownTime(endDateTime) {
        //Update the count down every 1 second
        var countDownTimer = setInterval(() => {
            // Get todays date and time
            var now = new Date().getTime();
            // Find the distance between now an the count down date
            var distance = endDateTime - now;

            // Time calculations for days, hours, minutes and seconds
            var days = ('0' + Math.floor(distance / (1000 * 60 * 60 * 24))).slice(-2);
            var hours = ('0' + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2);
            var minutes = ('0' + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
            var seconds = ('0' + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);

            this.setState(() => {
                return {
                    days: days,
                    hours: hours,
                    minutes: minutes,
                    seconds: seconds
                }
            });

            // If the count down is finished, write some text
            if (distance < 0) {
                if (typeof countDownTimer !== 'undefined') {
                    clearInterval(countDownTimer);
                }
                this.setState(() => {
                    return {
                        days: '00',
                        hours: '00',
                        minutes: '00',
                        seconds: '00'
                    }
                });
            }
        }, 1000);

        this.setState({ countDownTimer: countDownTimer });
    }

    /**
     * Method for checking promotion dates
     * @param {*} startDateTime 
     * @param {*} endDateTime 
     */
    checkPromotionDate(startDateTime, endDateTime) {
        if ((new Date() < startDateTime) && this.state.startPromotion == false) {
            //Priprema
            this.setState({ promotionText: 'Do promocije' });
            if (!this.setState.countDownTimer) {
                this.startBannerCountDownTime(startDateTime);
            }
        } else if (new Date() > endDateTime) {
            this.setState({ promotionFinished: true });
            clearInterval(this.state.countDownTimer);
            clearInterval(this.state.timerNajava);
        }
        else {
            //Pocetak
            this.setState({ promotionText: 'Trajanje promocije' });

            if (this.state.countDownTimer && this.state.startPromotion == false) {
                clearInterval(this.state.countDownTimer);
                this.startBannerCountDownTime(endDateTime);
                this.setState({ startPromotion: true });
            }
        };
    }

    isPromotionStarted() {
        return new Date().getTime() > new Date(this.props.info.aktivnoOd).getTime();
    }

    /**
   * Render method
   * @returns 
   */
    render() {
        return (
            <div className="subpage-casino-maraton-banner">
                <div className="img-container">
                    <div className="logo" />
                    <div className="rive-container">
                        <RiveComponent
                            lazyLoad={true}
                            cacheBust={`c=${casino.config.guiCacheVerzija}`}
                            src="content/images/bonusi/casinomaraton/brzinski_superskok_v2.riv"
                            stateMachines="State Machine 1"
                            useOffscreenRenderer={true}
                            playRequest={true}
                            disablePlayOutsideViewport={{ rootMargin: "-50px 0px 0px 0px", threshold: 0.25 }}
                        />
                    </div>
                </div>
                {/*<div className={this.props?.info?.id == 34 ? 'image xmas' : 'image'}></div>*/}
                {this.props.info && <div className="start">
                    {this.isPromotionStarted() && 'Započelo: '}
                    {!this.isPromotionStarted() && 'Počinje: '}
                    {casino.utils.dateToShortDateString(new Date(this.props.info.aktivnoOd))}. u {casino.utils.dateToTimeString(new Date(this.props.info.aktivnoOd))}</div>}
                <div className="promotion-text">{this.state.promotionText}</div>

                <div className="counter">
                    <div className="number">
                        <div className="text-number">{this.state.days}</div>
                        <div className="text-footer">Dana</div>
                    </div>

                    <div className="number">
                        <div className="text-number">{this.state.hours}</div>
                        <div className="text-footer">Sati</div>
                    </div>

                    <div className="number">
                        <div className="text-number">{this.state.minutes}</div>
                        <div className="text-footer">Min</div>
                    </div>

                    <div className="number">
                        <div className="text-number">{this.state.seconds}</div>
                        <div className="text-footer">Sek</div>
                    </div>
                </div>
            </div>
        );
    }

}